// import Axios from "axios";
import Axios from "axios";
// const baseUrl = "http://localhost:8080/";
const baseUrl = "https://backend.smecon.xyz/";
const getToken = () => localStorage.getItem("token");

export var postData = (route, data) => {
  return new Promise((resolve, reject) => {
    Axios.post(baseUrl + route, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${getToken()}`,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getData = (route) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${getToken()}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in get api", error);
        reject(error);
      });
  });
};

export const putData = (route, data) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${getToken()}`,
      },
      body: JSON.stringify(data), // PUT body
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in put api", error);
        reject(error);
      });
  });
};

export const patchData = (route, data) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${getToken()}`,
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const text = await response.text();
        const payload = text ? JSON.parse(text) : null;
        if (!response.ok) {
          const message =
            payload?.message ||
            payload?.error ||
            `Request failed (${response.status})`;
          throw new Error(message);
        }
        return payload;
      })
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in patch api", error);
        reject(error);
      });
  });
};

// deleteData function (DELETE request ke liye)
export const deleteData = (route) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${getToken()}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in delete api", error);
        reject(error);
      });
  });
};
